import React, { useEffect } from "react";
import SearchIcon from "../../assets/images/search.svg";
import CloseIcon from "../../assets/images/closeIcon.svg";
import {
  PlaceholderText,
  SearchIconWrapper,
  SearchInput,
  SearchWrapper,
  CloseIconWrapper,
} from "./SearchStyled";
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from "react-redux";
import { setSearch,setInputValue, setCurrentPage } from "../../slice/Matterslice";

const  Search = ({ searchbarwidth = "380px", searchbarheight = "32px", searchPlaceholder,isLoading }) => {
  const dispatch = useDispatch();
  const { inputValue } = useSelector((state) => state.matter);

  // Debounce logic
  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      dispatch(setSearch(inputValue));
    }, 1000); 

    return () => clearTimeout(delayDebounce); // Cleanup on change
  }, [inputValue, dispatch]);

  const handleInputChange = (e) => {
    if(!isLoading) {
      dispatch(setInputValue(e.target.value));
    }
      dispatch(setCurrentPage(1))
  };

  const handleClearSearch = () => {
    if(!isLoading) {
      dispatch(setInputValue(''));
      dispatch(setSearch(''));
    }
  };

  return (
    <SearchWrapper>
      <SearchIconWrapper src={SearchIcon} alt="Search" />
      <SearchInput
        type="text"
        onChange={handleInputChange}
        value={inputValue}
        maxLength={200}
        searchbarwidth={searchbarwidth}
        searchbarheight={searchbarheight}
        placeholder="Search" //Fix for autosave bug. Do not remove
      />
      {!inputValue && (
        <PlaceholderText>
          {searchPlaceholder}
        </PlaceholderText>
      )}
      <CloseIconWrapper
        src={CloseIcon}
        alt="Clear search"
        show={inputValue && inputValue.length > 0}
        onClick={handleClearSearch}
      />
    </SearchWrapper>
  );
};

Search.propTypes = {
  searchPlaceholder: PropTypes.string.isRequired,
  searchbarwidth: PropTypes.string,
  searchbarheight: PropTypes.string,
  isLoading:PropTypes.bool,
};

export default Search;
